debounce = (fn, delay)->
    timeoutID = null
    return ()->
        clearTimeout(timeoutID)
        args = arguments
        that = this
        timeoutID = setTimeout(()->
              fn.apply(that, args)
        , delay)

fromStorage = (key)->
    ret = null
    ret = localStorage.getItem(key);
    return ret

toStorage = (key, value)->
    ret = null
    localStorage.setItem(key, value);
    return ret



highlight_element = (el, times)->
    console.log("fields", el.style)
    el.style['background-color'] = "#F00"
    el.style["transition"] = "background-color 0.09s ease"
    setTimeout( ()->
        el.style['background-color'] = "#FFF"
    , 150)
    if times-1 > 0
        setTimeout( ()->
            highlight_element(el, times-1)
        , 300)


languageMapping = (language) ->
    ret = switch language
        when "en" then "gb"
        when "da" then "dk"
        when "ca" then "es"
        when "he" then "il"
        when "iw" then "il"
        when "yi" then "il"
        when "sv" then "se"
        when "vi" then "vn"
        when "uk" then "ua"
        when "cs" then "cz"
        when "sl" then "si"
        when "zh" then "cn"
        when "ko" then "kr"
        when "et" then "ee"
        when "am" then "et"
        when "ga" then "ie"
        when "el" then "gr"
        when "ka" then "ge"
        when "hi" then "in"
        when "te" then "in"
        when "ja" then "jp"
        when "nb" then "no"
        when "tha" then "th"
        when "ny" then "mw"
        else language
    return ret


export default {
    debounce
    fromStorage
    toStorage
    highlight_element
    languageMapping
}
